import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuSubmenuRootProps extends PartProps<BaseContextMenu.SubmenuRoot.Props> {}

function ContextMenuSubmenuRoot({ children, ...props }: ContextMenuSubmenuRootProps) {
  return <BaseContextMenu.SubmenuRoot {...props}>{children}</BaseContextMenu.SubmenuRoot>
}

export { ContextMenuSubmenuRoot }
